import service from './service'
// import axios from "axios";
// get请求封装
export function get (url, params) {
  return new Promise((resolve, reject) => {
    service.get(url, { params: params })
      .then(res => {
        if (res) {
          resolve(res.data)
        }
      })
      .catch(err => {
        reject(err)
      })
  })
}
// post请求封装
export function post (url, params) {
  return new Promise((resolve, reject) => {
    // post请求需要将请求数据转换成json格式
    service.post(url, params)
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}
// delete请求封装
export function Delete (url, params) {
  return new Promise((resolve, reject) => {
    service.delete(url, { params: params })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}
// deletes请求封装
export function Deletes (url, params) {
  return new Promise((resolve, reject) => {
    service.delete(url, { data: params })
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}
// put请求封装
export function put (url, params) {
  return new Promise((resolve, reject) => {
    service.put(url, params)
      .then(res => {
        resolve(res.data)
      })
      .catch(err => {
        reject(err.data)
      })
  })
}
